export default function Layout({ children }) {
  return (
    <div className="min-h-screen overflow-x-hidden font-inconsolata px-6 sm:px-10 md:px-20">
      {children}
    </div>
  );
}
